import React from "react";
import { Navigate, useParams } from "react-router-dom";
import InstructorDashboard from "views/instructor/default";
import InstructorProfilePage from "views/instructor/profile";
import CoursesListPage from "views/instructor/courses/list/CoursesListPage";
import NewCoursePage from "views/instructor/courses/new/NewCoursePage";
import CourseWorkspaceLayout from "views/instructor/courses/workspace/CourseWorkspaceLayout";
import BundlesListPage from "views/instructor/bundles/list/BundlesListPage";
import BundleFormPage from "views/instructor/bundles/form/BundleFormPage";
import StudentsPage from "views/instructor/students/StudentsPage";
import StudentDetailsPage from "views/instructor/students/StudentDetailsPage";
import MessagesInboxPage from "views/instructor/messages/MessagesInboxPage";
import DirectChatThreadPage from "views/instructor/messages/DirectChatThreadPage";
import AccountsPage from "views/instructor/accounts/AccountsPage";
import InstructorSignIn from "views/auth/InstructorAuthPage";
import {
  MdAccountBalanceWallet,
  MdChat,
  MdHome,
  MdLayers,
  MdMenuBook,
  MdPeopleAlt,
  MdPerson,
} from "react-icons/md";

function LegacyCourseOverviewRedirect() {
  const { legacyCourseId } = useParams();
  if (!legacyCourseId) return <Navigate to="/instructor/courses" replace />;
  return <Navigate to={`/instructor/courses/${legacyCourseId}/overview`} replace />;
}

const routes = [
  {
    name: "الرئيسية",
    nameAr: "الرئيسية",
    nameEn: "Home",
    layout: "/instructor",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <InstructorDashboard />,
  },
  {
    name: "الكورسات",
    nameAr: "الكورسات",
    nameEn: "Courses",
    layout: "/instructor",
    path: "courses",
    icon: <MdMenuBook className="h-6 w-6" />,
    component: <CoursesListPage />,
  },
  {
    name: "كورس جديد",
    nameAr: "كورس جديد",
    nameEn: "New course",
    layout: "/instructor",
    path: "courses/new",
    icon: <MdMenuBook className="h-6 w-6" />,
    component: <NewCoursePage />,
    hideInSidebar: true,
  },
  {
    name: "مساحة الكورس",
    nameAr: "مساحة الكورس",
    nameEn: "Course workspace",
    layout: "/instructor",
    path: "courses/:courseId/*",
    icon: <MdMenuBook className="h-6 w-6" />,
    component: <CourseWorkspaceLayout />,
    hideInSidebar: true,
  },
  {
    name: "إعادة توجيه نظرة عامة",
    nameAr: "إعادة توجيه نظرة عامة",
    nameEn: "Overview redirect",
    layout: "/instructor",
    path: ":legacyCourseId/overview",
    icon: <MdMenuBook className="h-6 w-6" />,
    component: <LegacyCourseOverviewRedirect />,
    hideInSidebar: true,
  },
  {
    name: "عروض الكورسات",
    nameAr: "عروض الكورسات",
    nameEn: "Course bundles",
    layout: "/instructor",
    path: "bundles",
    icon: <MdLayers className="h-6 w-6" />,
    component: <BundlesListPage />,
  },
  {
    name: "إنشاء عرض مجمع",
    nameAr: "إنشاء عرض مجمع",
    nameEn: "Create bundle",
    layout: "/instructor",
    path: "bundles/new",
    icon: <MdLayers className="h-6 w-6" />,
    component: <BundleFormPage />,
    hideInSidebar: true,
  },
  {
    name: "تعديل العرض",
    nameAr: "تعديل العرض",
    nameEn: "Edit bundle",
    layout: "/instructor",
    path: "bundles/:bundleId/edit",
    icon: <MdLayers className="h-6 w-6" />,
    component: <BundleFormPage />,
    hideInSidebar: true,
  },
  {
    name: "الطلاب",
    nameAr: "الطلاب",
    nameEn: "Students",
    layout: "/instructor",
    path: "students",
    icon: <MdPeopleAlt className="h-6 w-6" />,
    component: <StudentsPage />,
  },
  {
    name: "الرسائل",
    nameAr: "الرسائل",
    nameEn: "Messages",
    layout: "/instructor",
    path: "messages",
    icon: <MdChat className="h-6 w-6" />,
    component: <MessagesInboxPage />,
  },
  {
    name: "محادثة",
    nameAr: "محادثة",
    nameEn: "Conversation",
    layout: "/instructor",
    path: "messages/:conversationId",
    icon: <MdChat className="h-6 w-6" />,
    component: <DirectChatThreadPage />,
    hideInSidebar: true,
  },
  {
    name: "حساباتي",
    nameAr: "حساباتي",
    nameEn: "My accounts",
    layout: "/instructor",
    path: "accounts",
    icon: <MdAccountBalanceWallet className="h-6 w-6" />,
    component: <AccountsPage />,
  },
  {
    name: "تفاصيل الطالب",
    nameAr: "تفاصيل الطالب",
    nameEn: "Student details",
    layout: "/instructor",
    path: "students/:studentId",
    icon: <MdPeopleAlt className="h-6 w-6" />,
    component: <StudentDetailsPage />,
    hideInSidebar: true,
  },
  {
    name: "الملف الشخصي",
    nameAr: "الملف الشخصي",
    nameEn: "Profile",
    layout: "/instructor",
    path: "profile",
    icon: <MdPerson className="h-6 w-6" />,
    component: <InstructorProfilePage />,
  },
  {
    name: "تسجيل دخول المحاضر",
    nameAr: "تسجيل دخول المحاضر",
    nameEn: "Instructor sign in",
    layout: "/auth",
    path: "instructor-sign-in",
    icon: <MdPerson className="h-6 w-6" />,
    component: <InstructorSignIn />,
    hideInSidebar: true,
  },
];

export default routes;
